import { Form } from "devextreme-react";
import {
  EmptyItem,
  Label,
  RequiredRule,
  SimpleItem,
} from "devextreme-react/form";
import { vendorType } from "../data";
import ProjectDropDownBox from "../PaymentStatus/PaymentForm/ProjectDropDownButtonBox";
import { useDispatch, useSelector } from "react-redux";
import { DisplayFormat } from "devextreme-react/date-box";
import { useEffect, useState } from "react";
import axios from "axios";
import DataSource from "devextreme/data/data_source";
import {
  updateBasicInfo,
  updateContrPeriod,
  updateEndDate,
  updateMSA,
  updateName,
  updateProduct,
  updateRemark,
  updateStartDate,
  updateType,
  updateUnitCost,
  updateWODate,
} from "./Redux/vendorContract";
import styled from "styled-components";

const VendorContractFormWrapper = styled.div`
  .dx-field-item-required-mark {
    color: red;
  }

  .dx-datebox-calendar .dx-dropdowneditor-icon::before {
    content: "\f026";
  }
`;

export default function VendorContractForm(props) {
  const { projectDropDownBoxRef, vendorContract, formVendorContractRef } =
    props;

  //   const vendorContract = useSelector((state) => state.vendorContract);

  const [vendorDataSource, setVendorDataSource] = useState(null);

  useEffect(async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/vendor`
    );

    setVendorDataSource(
      new DataSource({
        store: {
          data: result.data,
          type: "array",
          key: "name",
        },
      })
    );
  }, []);

  const [productDataSource, setProductDataSource] = useState(null);

  useEffect(async () => {
    if (vendorContract.name && vendorContract.type) {
      const result = await axios.get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/vendor/product/${vendorContract.name}/${vendorContract.type}`
      );

      setProductDataSource(
        new DataSource({
          store: {
            data: result.data,
            type: "array",
            key: "product",
          },
        })
      );
    }
  }, [vendorContract.name, vendorContract.type]);

  const dispatch = useDispatch();

  const onNameValueChanged = (e) => {
    dispatch(
      updateName({
        name: e.value,
      })
    );
  };

  const onTypeValueChanged = (e) => {
    dispatch(
      updateType({
        type: e.value,
      })
    );
  };

  const onNameCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;

      return;
    }

    if (vendorDataSource) {
      const newItem = {
        name: args.text,
      };

      args.customItem = vendorDataSource
        .store()
        .insert(newItem)
        .then(() => vendorDataSource.load())
        .then(() => newItem)
        .catch((error) => {
          throw error;
        });
    }
  };

  const onProductValueChanged = (e) => {
    dispatch(
      updateProduct({
        product: e.value,
      })
    );
  };

  const onProductCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;

      return;
    }

    if (productDataSource) {
      const newItem = {
        product: args.text,
      };

      args.customItem = productDataSource
        .store()
        .insert(newItem)
        .then(() => productDataSource.load())
        .then(() => newItem)
        .catch((error) => {
          throw error;
        });
    }
  };

  const onMSAValueChanged = (e) => {
    dispatch(
      updateMSA({
        MSA: e.value ? e.value : null,
      })
    );
  };

  const onWODateValueChanged = (e) => {
    dispatch(
      updateWODate({
        WODate: e.value,
      })
    );
  };

  const onUnitCostValueChanged = (e) => {
    dispatch(
      updateUnitCost({
        unitCost: e.value,
      })
    );
  };

  const onContrPeriodValueChanged = (e) => {
    dispatch(
      updateContrPeriod({
        contrPeriod: e.value,
      })
    );
  };

  const onStartDateValueChanged = (e) => {
    dispatch(
      updateStartDate({
        startDate: e.value ? e.value : null,
      })
    );
  };

  const onEndDateValueChanged = (e) => {
    dispatch(
      updateEndDate({
        endDate: e.value ? e.value : null,
      })
    );
  };

  const onRemarkValueChanged = (e) => {
    dispatch(
      updateRemark({
        remark: e.value ? e.value : null,
      })
    );
  };

  return (
    <VendorContractFormWrapper>
      <Form
        ref={formVendorContractRef}
        colCount={4}
        labelMode={"outside"}
        labelLocation={"top"}
        showColonAfterLabel={true}
        style={{ padding: "16px" }}
        validationGroup={"vendorContractData"}
      >
        <SimpleItem
          dataField={"name"}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: vendorDataSource,
            showClearButton: true,
            displayExpr: "name",
            valueExpr: "name",
            acceptCustomValue: true,
            value: vendorContract.name,
            onValueChanged: onNameValueChanged,
            onCustomItemCreating: onNameCustomItemCreating,
          }}
        >
          <Label text={"Vendor Name"} />
          <RequiredRule message={"Vendor name is required."} />
        </SimpleItem>
        <SimpleItem
          dataField={"type"}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: vendorType,
            // dataSource: vendorTypeDataSource,
            valueExpr: "id",
            displayExpr: "name",
            showClearButton: true,
            value: vendorContract.type,
            onValueChanged: onTypeValueChanged,
          }}
        >
          <RequiredRule message={"Type is required."} />
        </SimpleItem>
        <SimpleItem
          dataField={"product"}
          editorType={"dxSelectBox"}
          editorOptions={{
            showClearButton: true,
            dataSource: productDataSource,
            valueExpr: "product",
            displayExpr: "product",
            acceptCustomValue: true,
            value: vendorContract.product,
            onValueChanged: onProductValueChanged,
            onCustomItemCreating: onProductCustomItemCreating,
          }}
        >
          <RequiredRule message={"Product name is required."} />
        </SimpleItem>
        <SimpleItem
          dataField={"MSA"}
          editorType={"dxTextBox"}
          editorOptions={{
            // inputAttr: {
            //   style: "text-align : right",
            // },
            showClearButton: true,
            value: vendorContract.MSA,
            onValueChanged: onMSAValueChanged,
          }}
        />
        <SimpleItem dataField={"contrNo"}>
          <Label text={"Contract No."} />
          <ProjectDropDownBox
            projectDropDownBoxRef={projectDropDownBoxRef}
            data={vendorContract}
            updateBasicInfo={updateBasicInfo}
            type={"payment"}
          />
          <RequiredRule message={"Contract No. is required."} />
        </SimpleItem>
        <SimpleItem
          dataField={"WODate"}
          editorType={"dxDateBox"}
          editorOptions={{
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            showClearButton: true,
            value: vendorContract.WODate,
            onValueChanged: onWODateValueChanged,
          }}
        >
          <Label text={"WO Date"} />
          {/* <RequiredRule message={"WO date is required."} /> */}
        </SimpleItem>
        <SimpleItem
          dataField={"unitCost"}
          editorType={"dxNumberBox"}
          editorOptions={{
            format: "#,##0",
            inputAttr: {
              style: "text-align : right",
            },
            showClearButton: true,
            value: vendorContract.unitCost,
            onValueChanged: onUnitCostValueChanged,
          }}
        >
          <Label text={"Unit Cost"} />
          <RequiredRule message={"Unit cost is required."} />
        </SimpleItem>
        <SimpleItem
          dataField={"contrPeriod"}
          editorType={"dxNumberBox"}
          editorOptions={{
            inputAttr: {
              style: "text-align : right",
            },
            showClearButton: true,
            value: vendorContract.contrPeriod,
            onValueChanged: onContrPeriodValueChanged,
          }}
        >
          <Label text={"Contract Period"} />
          <RequiredRule message={"Contract period is required."} />
        </SimpleItem>
        <SimpleItem
          dataField={"startDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            showClearButton: true,
            value: vendorContract.startDate,
            onValueChanged: onStartDateValueChanged,
          }}
        >
          <Label text={"Start Date"} />
        </SimpleItem>
        <SimpleItem
          dataField={"endDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            showClearButton: true,
            value: vendorContract.endDate,
            onValueChanged: onEndDateValueChanged,
          }}
        >
          <Label text={"End Date"} />
        </SimpleItem>
        <EmptyItem />
        <EmptyItem />
        <SimpleItem
          dataField={"remark"}
          colSpan={4}
          editorType={"dxTextArea"}
          editorOptions={{
            showClearButton: true,
            value: vendorContract.remark,
            onValueChanged: onRemarkValueChanged,
          }}
        />
      </Form>
    </VendorContractFormWrapper>
  );
}
